<template>
  <div style="width: 100%;height: 100%;display: flex;">
    <div style="width: 80%;height: 100%">
      <router-view></router-view>
    </div>
    <div style="width: 20%;height: 100%;">
      <div style="height: 8%;position:relative;">
        <el-button v-if="this.createuserid == 0" type="warning" style="float: right;margin: 10px 10px 0 0" @click="onFundAduit">初审</el-button>
        <el-button type="primary" style="float: right;margin: 10px 10px 0 0" @click="onBack">返回</el-button>
      </div>
      <el-timeline style="margin-top: 10%">
        <el-timeline-item
          size='large'
          v-for="(activity, index) in activities"
          :key="index">
          <router-link :to="activity.index" tag="span" style="cursor: pointer" active-class="routerActive"> {{ activity.content }}</router-link>
        </el-timeline-item>
      </el-timeline>
    </div>
    <fundAuidtPublicDialog
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      :pbcid="pbcid">
    </fundAuidtPublicDialog>
  </div>
</template>

<script>
import utils from "../../js/utils";
import fundAuidtPublicDialog from './fundAuidt_publicDialog'

export default {
  name: "projectHomePage",
  data() {
    return {
      queryData: {},
      createuserid: sessionStorage.getItem('createuserid'),
      isDisabled: false,
      // isDisabled: sessionStorage.getItem('openWith')=='readOnly' ? true : false,
      activities: [
        {content: '一、项目基本情况', index: '/HomePage/PJGLHomepage/projectHomePage/PrimaryInfo_01'},
        {content: '二、项目简介', index: '/HomePage/PJGLHomepage/projectHomePage/ProjectAbstract_02'},
        {content: '三、主要科技创新', index: '/HomePage/PJGLHomepage/projectHomePage/PrimaryScienceInnovate_03'},
        {content: '四、验收意见或第三方评价', index: '/HomePage/PJGLHomepage/projectHomePage/ThirdPartyEvaluation_04'},
        {content: '五、推广应用情况、经济效益和社会效益', index: '/HomePage/PJGLHomepage/projectHomePage/ProjectInfluence_05'},
        {content: '六、曾获科技奖励情况', index: '/HomePage/PJGLHomepage/projectHomePage/AcquiredAward_06'},
        {content: '七、主要知识产权证明目录', index: '/HomePage/PJGLHomepage/projectHomePage/IntellectualProperty_07'},
        {content: '八、论文专著目录', index: '/HomePage/PJGLHomepage/projectHomePage/Thesis_08'},
        {content: '九、主要完成人情况表', index: '/HomePage/PJGLHomepage/projectHomePage/CompletePerson_09'},
        {content: '十、主要完成单位情况表', index: '/HomePage/PJGLHomepage/projectHomePage/CompleteCompany_10'},
        {content: '十一、推荐单位意见', index: '/HomePage/PJGLHomepage/projectHomePage/RecommendOpinions_11'},
        {content: '十二、附件', index: '/HomePage/PJGLHomepage/projectHomePage/attachment_12'},
      ],
      dialogVisible: false,
      pbcid: sessionStorage.getItem('pbcid'),
    }
  },
  components: {
    fundAuidtPublicDialog
  },
  methods: {
    onBack() {
      //createuserid==1 用户，createuserid==0 管理员
      if (this.createuserid == 1) {
        this.$router.push({
          path: '/HomePage/PJGLHomepage/AduitAward_Company'
        })
      } else if (this.createuserid == 0) {
        this.$router.push({
          path: '/HomePage/PJGLHomepage/AduitAward_Manager',
          query: this.queryData
        })
      }
    },
    onFundAduit() {
      this.dialogVisible = true
    },
  },
  created() {
    this.queryData = this.$route.query
  }
}
</script>

<style scoped>
.routerActive {
  color: #409EFF;
}

</style>



// WEBPACK FOOTER //
// src/views/PJGL/ProjectSequence/projectHomePage.vue